module.exports = __webpack_public_path__ + "img/djyl-banner-pic.3a588358.png";